// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2x7FJ","load8":"Spinner_load8__b_ULz"};